<template>
  <div class="client-container">
    <el-row class="tcf-row">
      <el-col :span="24" class="card">
        <div class="card-body">
          <div class="card-title">
            方案跟进
          </div>
          <div class="card-content" v-loading="loading">
            <el-row>
              <el-col :span="5">
                <el-row>
                  <el-col :span="24" class="client-info-row">
                    <span class="client-name">{{assignInfo.all_name}}</span>
                  </el-col>
                  <el-col :span="24" class="client-info-row row-line">
                    <el-tag type="danger" size="mini" v-if="assignInfo.mark===0">未开始</el-tag>
                    <el-tag type="warning" size="mini" v-if="assignInfo.mark===1">进行中</el-tag>
                    <el-tag size="mini" v-if="assignInfo.mark===2">已完成</el-tag>
                  </el-col>
                  <el-col :span="24" class="client-info-row">
                    <span style="color:#99a9bf">目前阶段：</span> {{assignInfo.assign_name}}
                  </el-col>
                  <el-col :span="24" class="client-info-row">
                    <span style="color:#99a9bf">起始日期：</span> {{assignInfo.start_time}}
                  </el-col>
                  <el-col :span="24" class="client-info-row row-line">
                    <span style="color:#99a9bf">结束日期：</span> {{assignInfo.end_time}}
                  </el-col>
                  <el-col :span="24" class="client-info-row">
                    <span style="color:#99a9bf">排期人员：</span> {{assignInfo.planusername}}
                  </el-col>
                  <el-col :span="24" class="client-info-row">
                    <span style="color:#99a9bf">排期时间：</span> {{assignInfo.plantime}}
                  </el-col>
                  <el-col :span="24" class="client-info-row">
                    <span style="color:#99a9bf">指派人员：</span> {{assignInfo.assignusername}}
                  </el-col>
                  <el-col :span="24" class="client-info-row row-line">
                    <span style="color:#99a9bf">指派时间：</span> {{assignInfo.assigntime}}
                  </el-col>
                  <el-col :span="24" class="client-info-row">
                    已有<span style="font-size: 14px;font-weight: 500;color:#409EFF;margin:0 6px">{{assignInfo.follownum}}</span>次跟进
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="19">
                <el-timeline>
                  <el-timeline-item v-if="addRule" timestamp="" placement="top">
                    <el-button size="small" type="primary" @click="addRecord">添加跟进</el-button>
                  </el-timeline-item>
                  <el-timeline-item v-for="ritem in datainfo.followList" :timestamp="ritem.time" placement="top">
                    <el-card>
                      <el-button v-if="ritem.userid===user.dUserid&&assignInfo.mark!==2" @click="editRecord(ritem)" class="follow-editbtn" type="text" size="small" icon="el-icon-edit">编辑</el-button>
                      <h4 class="follow-txt">
                        <i class="el-icon-time" style="color:#E6A23C" v-if="ritem.mark===0"></i>
                        <i class="el-icon-success" style="color:#67C23A" v-if="ritem.mark===1"></i>
                        {{ritem.psname}}
                        <span style="margin:0 20px">
                          <i class="el-icon-user-solid" style="color:#99a9bf"></i>
                          {{ritem.username}}
                        </span>
                        <el-tag v-if="ritem.overdue===2" size="mini" :disable-transitions="true" type="success" style="font-weight: 400">提早完成</el-tag>
                        <el-tag v-if="ritem.overdue===1" size="mini" :disable-transitions="true" type="danger" style="font-weight: 400">逾期 {{ritem.overdueday}} 天</el-tag>
                      </h4>
                      <p class="follow-content"> {{ritem.remark}}</p>
                      <div>
                        <el-image v-for="img in ritem.imgList"
                                  style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
                                  :src="img.imgurl"
                                  :preview-src-list="ritem.imgurls">
                        </el-image>
                      </div>
                    </el-card>
                  </el-timeline-item>
                  <el-timeline-item :timestamp="assignInfo.plantime" placement="top">
                    <el-card>
                      <h4 class="follow-txt">方案排期</h4>
                      <p class="follow-content">由&nbsp;<span style="color:#409EFF">{{assignInfo.planusername}}</span>&nbsp;排期
                      </p>
                    </el-card>
                  </el-timeline-item>
                </el-timeline>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="addTitle"
      :visible.sync="addVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="addForm" :model="addForm" :rules="rulesAdd"  label-position="right" label-width="75px" size="small">
        <el-form-item label="当前阶段" prop="assign_name">
          <el-input v-model="addForm.assign_name" :disabled="true">
          </el-input>
        </el-form-item>
        <el-form-item label="阶段进度" prop="isfinish">
          <el-radio :disabled="editDisabled" v-model="addForm.isfinish" :label="0">进行中</el-radio>
          <el-radio :disabled="editDisabled" v-model="addForm.isfinish" :label="1">已完成</el-radio>
        </el-form-item>
        <el-form-item label="阶段图片" prop="imgids">
          <MultiImg :limit="9" :size="'sm'"  :old="editimgList" :key="imgLoad" ref="img" v-model="addForm.imgids" />
        </el-form-item>
        <el-form-item label="跟进内容" prop="remark">
          <el-input type="textarea" v-model="addForm.remark" maxlength="200" show-word-limit></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="addLoading" @click="submitForm('addForm')">立即提交</el-button>
          <el-button @click="addVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getAssignFollowList, addOrEditAssignFollow } from '@/api/work'
import MultiImg from '@/components/upload/MultiImg'

export default {
  name: 'ExhibitionHomepage',
  computed: {
    user: getUser
  },
  components: {
    MultiImg
  },
  data() {
    return {
      eid: undefined,
      assignInfo: {},
      tempRoute: {},
      loading: false,
      datainfo: [],
      addVisible: false,
      addTitle: '添加跟进记录',
      addRule: false,
      addLoading: false,
      imgLoad: '',
      editDisabled: false,
      editimgList: [],
      addForm: {
        assignid: 0,
        assign_name: '',
        isfinish: 0,
        imgids: [],
        remark: ''
      },
      rulesAdd: {
        assign_name: [{ required: true, message: '当前阶段', trigger: 'blur' }],
        isfinish: [{ required: true, message: '请选择阶段进度', trigger: 'change' }],
        remark: [{ required: true, message: '请输入跟进内容', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.tempRoute = Object.assign({}, this.$route)
    this.eid = this.$route.params && this.$route.params.id
    this.getData()
  },
  methods: {
    getData() {
      if (this.eid !== null && this.eid !== undefined && this.eid !== '') {
        this.loading = true
        getAssignFollowList({ exid: this.eid }).then(response => {
          this.loading = false
          const pageTitle = `方案跟进 - ${response.data.assignInfo.all_name}`
          this.assignInfo = response.data.assignInfo
          document.title = pageTitle
          const route = Object.assign({}, this.tempRoute, { title: pageTitle })
          this.$store.dispatch('tagsView/updateVisitedView', route)
          this.datainfo = response.data
          this.addForm.assign_name = this.datainfo.assignInfo.assign_name
          if (this.datainfo.assignInfo.mark !== 2) {
            if (this.datainfo.assignInfo.planid === this.user.dUserid || this.datainfo.assignInfo.assignid === this.user.dUserid) {
              this.addRule = true
            } else {
              for (let p of this.datainfo.planList) {
                if (p.psid === this.datainfo.assignInfo.assign_id) {
                  if (this.user.dUserid === p.userid) {
                    this.addRule = true
                  }
                  break
                }
              }
            }
          }
        }).catch(() => {
          this.loading = false
        })
      } else {
        this.$message.error('获取展厅方案信息失败')
      }
    },
    addRecord() {
      this.editDisabled = false
      this.addForm.assign_name = this.datainfo.assignInfo.assign_name
      this.addForm.assignid = 0
      this.addForm.isfinish = 0
      this.addForm.imgids = []
      this.addForm.remark = ''
      this.addTitle = '添加跟进记录'
      this.addVisible = true
      this.imgLoad = new Date().getTime()
      this.editimgList = []
    },
    editRecord(ef) {
      this.editDisabled = true
      this.addForm.assign_name = ef.psname
      this.addForm.assignid = ef.efid
      this.addForm.isfinish = ef.mark
      let oldimgids = []
      for (let img of ef.imgList) {
        oldimgids.push({ id: img.imgid, url: img.imgurl })
      }
      this.editimgList = oldimgids
      this.imgLoad = new Date().getTime()
      this.addForm.imgids = []
      this.addForm.remark = ef.remark
      this.addTitle = '编辑跟进记录'
      this.addVisible = true
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.addLoading) {
            this.addLoading = true
            const data = {
              isfinish: this.addForm.isfinish,
              psid: this.datainfo.assignInfo.assign_id,
              userid: this.user.dUserid,
              exid: this.datainfo.assignInfo.ex_id,
              remark: this.addForm.remark,
              imgStr: this.addForm.imgids.join(','),
              assignid: this.addForm.assignid
            }
            addOrEditAssignFollow(data).then(response => {
              this.$message({
                message: '方案跟进记录提交成功',
                type: 'success'
              })
              this.addLoading = false
              this.addVisible = false
              this.getData()
            }).catch(() => {
              this.addLoading = false
              return false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.client-container {
  .client-name{
    letter-spacing: 2px;
    color:#000;
  }
  .client-info-row{
    padding:6px 0;
  }
  .row-line{
    border-bottom: 1px solid #f5f7fa;
    padding-bottom: 14px;
    margin-bottom: 10px;
  }
  .client-sex{
    width: 16px!important;
    height: 16px!important;
    vertical-align: -4px!important;
  }
  .follow-txt{
    font-size: 13px;
  }
  .follow-content{
    color:#999;
    font-size: 13px;
  }
  .follow-editbtn{
    position: absolute;
    right:20px;
    top:40px;
  }
  .tags-container{
    width: 100%;
    position: relative;
    padding: 20px;
    .tags-item{
      position: relative;
      padding: 9px 15px;
      background: #FFF;
      border: 1px dashed #DCDFE6;
      border-radius: 4px;
      display: inline-block;
      color: #606266;
      font-size: 12px;
      font-weight: 500;
      margin:0 20px 20px 0;
      .tags-del{
        padding: 2px!important;
        font-size: 10px!important;
        position: absolute;
        right: -10px;
        top: -6px;
      }
    }
  }
}
</style>
